export default __webpack_public_path__ + "testimonial-background.8f9cda.png";